import * as t from 'io-ts';

import {makeApiType, RApiTokenIdRef, RLazyTeammateIdRef} from './apiTypes';

/*
 * Constants.
 */

export enum ApiTokenScopesEnum {
  SHARED = 'shared:*',
  PRIVATE = 'private:*',
  AUTO_PROVISIONING = 'scim',
  PROVISIONING = 'provisioning',
  TEAM = 'team',
}

/*
 * Runtime types.
 */

const RApiTokenDirty = t.readonly(
  t.intersection([
    t.type({
      id: t.Integer,
      isActive: t.boolean,
      createdAt: t.Integer,
      lastUsedAt: t.Integer,
      updatedAt: t.Integer,
      scopes: t.readonlyArray(t.string),
      jwt: t.string,
      publicId: t.string,
    }),
    t.partial({
      ownerId: RLazyTeammateIdRef,
      name: t.string,
    }),
  ]),
);

/*
 * Types.
 */

export interface ApiTokenModel extends t.TypeOf<typeof RApiTokenDirty> {}
export const RApiToken = t.clean<ApiTokenModel>(RApiTokenDirty as any);
RApiTokenIdRef.setTargetType(RApiToken);

/*
 * IO methods.
 */

export function parseApiToken(src: any): ApiTokenModel {
  return {
    id: src.id,
    isActive: src.active,
    name: src.name,
    jwt: src.jwt,
    ownerId: src.owner_id,
    scopes: src.scopes,
    publicId: src.public_id,
    createdAt: src.created_at,
    lastUsedAt: src.last_used_at ?? 0,
    updatedAt: src.updated_at ?? 0,
  };
}

/*
 * API types.
 */

export const ApiApiToken = makeApiType('apiToken', RApiToken, parseApiToken);
